// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5f930755","453":"65069a75","732":"39deb1f5","977":"810dd4e5"}[chunkId] + ".chunk.js";
};